import { Divider, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { HealthRecordEvent } from "@/services/core-api-adapter";
import type { DefaultHealthRecordCardTypeProps } from "@/features/MyHealth/components/HealthRecordCard";
import { healthRecordCardLabelStyle } from "@/features/MyHealth/components/HealthRecordCard";
import type { consultationDetails } from "@/features/MyHealth/components/HealthRecordCard/details";

type Details = NonNullable<ReturnType<typeof consultationDetails>>;
const labels = {
  consultDate: "HealthRecordCardType.CONSULTATION.consultDate",
  selectedService: "HealthRecordCardType.CONSULTATION.selectedService",
  partnerPlanName: "HealthRecordCardType.CONSULTATION.partnerPlanName",
  amount: "HealthRecordCardType.CONSULTATION.amount",
  billed: "HealthRecordCardType.CONSULTATION.billed",
} as const;

export default function HealthRecordCardTypeConsultation({
  data,
}: DefaultHealthRecordCardTypeProps & { data: HealthRecordEvent }) {
  const { t } = useTranslation();
  const details = data.details as Details;
  return (
    <Stack spacing={2} sx={{ minWidth: 0, overflowWrap: "anywhere" }}>
      <Divider />
      {details.caption && (
        <Typography variant="body2">{details.caption}</Typography>
      )}
      {details.data.map((row, index) => (
        <Stack key={row.type + index} spacing={0.5}>
          <Typography sx={healthRecordCardLabelStyle}>
            {t(labels[row.type as keyof typeof labels])}
          </Typography>
          <Typography variant="body2">{row.value}</Typography>
        </Stack>
      ))}
    </Stack>
  );
}
